import { Typography, Button } from "components/atoms";
import classNames from "classnames";
import { YellowClock } from "components/atoms/Icon/YellowClock";
import { Select } from "components/atoms/Icon/Select";
import { EmptyCircle } from "components/atoms/Icon/EmptyCircle";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/molecules";
import "./index.scss";
import { ReactNode } from "react";

interface IProps {
  title: string | ReactNode;
  status?: string;
  onClick: () => void;
  theme: "light" | "dark";
  type: "drills" | "video" | "offline-drills";
  fullTitle?: string;
  shouldShowTooltip?: boolean;
  widgetTrackingId?: string;
}

export const DrillCard = ({
  title,
  status = "Completed",
  theme,
  type,
  fullTitle,
  shouldShowTooltip,
  widgetTrackingId,
  onClick,
}: IProps) => {
  const extractBtnLabel = (type: string, status: string) => {
    if (type === "drills") {
      switch (status) {
        case "Not Started":
        case "Pending":
          return "Start Drill";
        case "In Progress":
        case "InProgress":
        case "In-Progress":
          return "Resume";
        case "Completed":
          return "Retake Drill";
        default:
          break;
      }
    } else if (type === "video") {
      switch (status) {
        case "Not Started":
        case "Pending":
          return "Start Lesson";
        case "In Progress":
        case "InProgress":
        case "In-Progress":
          return "Resume";
        case "Completed":
          return "Restart Lesson";
        default:
          break;
      }
    } else if (type === "offline-drills") {
      return "Update Status";
    } else {
      return "Update Status";
    }
  };

  return (
    <div className="drill-card-wrapper">
      <div className="typography-wrapper">
        <div className={classNames("card-status-icons")}>
          {status === "In Progress" ||
          status === "InProgress" ||
          status === "In-Progress" ? (
            <YellowClock />
          ) : status === "Completed" ? (
            <Select />
          ) : status === "Not Started" || status === "Pending" ? (
            <EmptyCircle theme={theme} />
          ) : null}
        </div>
        <Tooltip>
          <TooltipTrigger>
            <Typography
              label={title}
              variant="h7Bold"
              styles="custom-typography-style"
            />
          </TooltipTrigger>
          {shouldShowTooltip ? (
            <TooltipContent className={`study-recommend-tooltip-${theme}`}>
              {fullTitle}
            </TooltipContent>
          ) : null}
        </Tooltip>
      </div>
      <div className="drill-btn-wrapper">
        <Button
          label={extractBtnLabel(type, status)}
          icon={false}
          styles="custom-btn-style"
          type="score"
          onClick={onClick}
          dataTrackingId={widgetTrackingId}
        />
      </div>
    </div>
  );
};
